import { createFetcher } from "api/helpers"

const fetcherConfiguration = {
  makeRequestUrl: (host, user) => {
    return `${host}/users/${user}/role`
  },
  checkRequiredArguments: (user) => {
    if (user === "undefined") throw Error("No user defined.")
  },
  makeResponseData: (data) => {
    return data
  }
}
export default createFetcher(fetcherConfiguration)
